


































/* General */
import { IPersonBase } from '@/api/types/response.types'
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */
import UserAPI from '@/api/modules/user.api'

export default Vue.extend({
  name: 'WhosViewingIndicator',

  props: {
    itemId: {
      type: Number,
      required: true,
    },
    largerBottomSpace: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      /* Presence data ("Who's viewing ticket?") */
      presenceChannel: null,
      viewers: [] as IPersonBase[],
      mobileRevealClicked: false,
    }
  },

  computed: {
    pusherPresenceChannelID(): string {
      return `presence-item-detail-${this.itemId}`
    },
    hasViewers(): boolean {
      return this.viewers && this.viewers.length > 0 // "You" will always be there
    },
  },

  watch: {
    'presenceChannel.members.count': {
      immediate: true,
      handler(value) {
        if (!this.presenceChannel) {
          return
        }
        this.viewers = []
        // @ts-ignore
        this.presenceChannel.members.each(member => {
          if (this.$permissions.loggedInUser.id !== +member.id) {
            this.viewers.push({
              id: member.id,
              name: member.info.name,
              photoUrl: member.info.avatar_url,
            })
          }
        })
      },
    },
  },

  async created() {
    const authHeader = await UserAPI.get_PusherAuthHeaderValue()
    this.$pusher.config.auth.headers['X-Pusher-DD-Auth'] = authHeader.value
    this.presenceChannel = this.$pusher.subscribe(this.pusherPresenceChannelID)
  },

  beforeDestroy() {
    if (this.presenceChannel) {
      this.$pusher.unsubscribe(this.pusherPresenceChannelID)
    }
  },

  methods: {},
})
